export const headerScrollListenter = () => {
  const headeWrapper = document.getElementById('header')
  const ziro = 0
  if (window.pageYOffset > ziro) {
    headeWrapper.classList.add('is-sticky')
  } else {
    headeWrapper.classList.remove('is-sticky')
  }
  window.addEventListener('scroll', () => {
    if (window.pageYOffset > ziro) {
      headeWrapper.classList.add('is-sticky')
    } else {
      headeWrapper.classList.remove('is-sticky')
    }
  })
}



// WEBPACK FOOTER //
// ./src/js/components/js-component/sticky-header.js